import { Capacitor } from '@capacitor/core';

/**
 * Platform detection utilities for TableView POS app
 */

export const Platform = {
  /**
   * Check if app is running on web browser
   */
  isWeb: () => {
    return !Capacitor.isNativePlatform() && !(window as any).electronAPI;
  },

  /**
   * Check if app is running in Electron (Desktop)
   */
  isElectron: () => {
    return !!(window as any).electronAPI;
  },

  /**
   * Check if app is running on iOS (Capacitor)
   */
  isIOS: () => {
    return Capacitor.getPlatform() === 'ios';
  },

  /**
   * Check if app is running on Android (Capacitor)
   */
  isAndroid: () => {
    return Capacitor.getPlatform() === 'android';
  },

  /**
   * Check if app is running on any mobile platform (iOS or Android)
   */
  isMobile: () => {
    return Capacitor.isNativePlatform();
  },

  /**
   * Check if app is running on desktop (Electron or Web)
   */
  isDesktop: () => {
    return !Capacitor.isNativePlatform();
  },

  /**
   * Get the current platform name
   */
  getPlatform: () => {
    if ((window as any).electronAPI) return 'electron';
    return Capacitor.getPlatform();
  },

  /**
   * Check if thermal printing is available
   * Only available on Electron desktop app
   */
  canPrintThermal: () => {
    return !!(window as any).electronAPI?.printThermalReceipt;
  },

  /**
   * Check if the device has a native share dialog
   */
  canNativeShare: () => {
    return Capacitor.isNativePlatform() && navigator.share !== undefined;
  }
};

export default Platform;
